// extracted by mini-css-extract-plugin
export default {"wrap":"grammarActivity_wrap__jwwIi","content":"grammarActivity_content__RlXLy activityStyles_activityPadding__gTKKg","exercisesWrap":"grammarActivity_exercisesWrap__pm7XE"};